import React, { useContext } from 'react';

import { FORM_KEYS } from './constants/form-manager.constants';
import { FormContext } from './context';
import DynamicField from './DynamicField';
import { getRootElements } from './selectors/form-manager.selectors';
import { equalityFn } from './utils/form-manager.utils';
import { useFormSelector } from '../custom-hooks';

// handle all generic form actions
const FormManager = ({ isDetail = false }) => {
  const rootElements = useFormSelector(getRootElements, {}, equalityFn);
  const formKey = useContext(FormContext);
  const isEditor = formKey === FORM_KEYS.EDITOR;

  return (
    <div id="formManager" style={{ overflow: 'auto', overflowX: isEditor ? 'auto' : 'hidden' }}>
      {rootElements &&
        Object.keys(rootElements).map((key) => (
          <DynamicField key={rootElements[key]} id={rootElements[key]} isDetail={isDetail} />
        ))}
    </div>
  );
};

export default FormManager;
